import {DisbursementType, PaymentType} from "@app/shared/enums/payment-type.enum";
import {ShippingType} from "@app/shared/enums/shipping-type.enum";

export class PartnerPaymentSetting {
  id?: number;
  version?: number;

  accountNumber: string;
  creditLimit: number;
  specialDiscount: number;
  preferDeliveryType: ShippingType;
  preferPaymentType: DisbursementType;
  onlinePayment: boolean;

  partnerId: number;
  paymentTermsId: number;

  paymentTermsName?: string;           // transient
  displayAccountNumber?: string;
}